<template>
    <div class="container-fluid">
    <!-- Start Row 1 Topbar-->
    <!--<div class="row">
        <div class="col-md-12 ">
            <Topbar />
        </div>
    </div>-->
    <!-- Start Row 2 Navigation
    <div class="row">
        <div class="col-md-12 ">
            <Navigation />
        </div>
    </div>-->

    <!-- Start Row 2 Hero-->
    <div class="row">
        <div class="col-md-12 ">
            <Hero />
        </div>
    </div>

    <!-- Start Row 2 features-->
    <div class="row">
        <div class="col-md-12 ">
            <features />
        </div>
    </div>

    <!-- Start Row 2 Experience-->
    <div class="row">
        <div class="col-md-12 ">
            <Experience />
        </div>
    </div>

    <!-- Start Row 2 Services-->
    <div class="row">
        <div class="col-md-12 ">
            <Services />
        </div>
    </div>

    <!-- Start Row 2 Why choose us-->
    <div class="row">
        <div class="col-md-12 ">
            <Choose />
        </div>
    </div>

    <!-- Start Row 2 Footer
    <div class="row">
        <div class="col-md-12 ">
            <Test />
        </div>
    </div>-->
</div>
</template>
<script>

//import Topbar from '../components/TopBarPage.vue'
//import Navigation from '../components/NavigationPage.vue'
import Hero from '../components/HeroPage.vue'
import Features from '../components/FeaturesPage.vue'
import Experience from '../components/ExperiencePage.vue'
import Services from '../components/ServicesPage.vue'
import Choose from '../components/ChoosePage.vue'
//import Test from '../layouts/TestPage.vue'

    export default{
        name: 'IndexPage',
        components:{
            //Topbar, //Navigation,
             Hero, Features, Experience,
            Services, Choose, //Test,
        }
    }
</script>
<style>
    /* .border{
        border: 3px solid #000;
    } */
</style>